import { render } from "./Receta_RecetaDet.vue?vue&type=template&id=03511c94&scoped=true"
import script from "./Receta_RecetaDet.vue?vue&type=script&lang=js"
export * from "./Receta_RecetaDet.vue?vue&type=script&lang=js"

import "@/assets/css/microfono.css?vue&type=style&index=0&id=03511c94&scoped=true&lang=css"
import "@/assets/css/listaFiltrada02.css?vue&type=style&index=1&id=03511c94&scoped=true&lang=css"
import "./Receta_RecetaDet.vue?vue&type=style&index=2&id=03511c94&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03511c94"]])

export default __exports__